import {createAction} from 'redux-actions'

const actions = actionTypes =>
  Object.keys(actionTypes).reduce((out, actionType) => {
    out[actionType] = createAction(actionType)
    return out
  }, {})

export default actions
